import axios from "axios"
import i18n from "../localization"
import Notifications from "./Notifications"
import isRu from "./isRu"

export default function sign(b64, isFile, address){
    return(axios({
        data   : { data: b64, isDetached : "true" },
        method : 'post',
        url    : `${ address }/sign`
    })
        .then(res => {
            return({
                error: false,
                res : res
            })
        })
        .catch(errInfo => {
            if (errInfo.data?.error){
                switch (errInfo.data?.error){
                    case "5":
                        Notifications.infoNotice(`${ i18n.errorInfoWithSign[isRu()]}`, "", 5)
                        break
                    default:
                        Notifications.errorNotice(`${ isFile ? i18n.errorWithFileSignInCP[isRu()] : i18n.errorWithTextSignInCP[isRu()] } ${ errInfo.data?.error }`, "", 5)
                        break
                }
            } 
            else
                Notifications.errorNotice(i18n.errorWithCPAccess[isRu()], "", 5)
            return({
                error : true,
                res : null
            })
        }))
}